import { Checkbox } from '@mui/material';
import { Controller } from 'react-hook-form';
export const InputCheckbox = ({ name, control, register }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Checkbox
          {...register(name)}
          errors={error}
          checked={!!value}
          onChange={e => {
            onChange(e.target.checked);
          }}
        />
      )}
    />
  );
};
